<template>
  <div>
    <div class="modal full" id="modalPedido" tabindex="-1" :class="{'d-block': opened}">
      <div class="modal-content">
        <div class="container-fluid px-3">
          <div class="d-flex align-items-center text-right border-bottom" style="padding-bottom: 12px; margin-bottom: 12px">
            <h6 class="font-weight-bold mb-0 pointer" @click="changeEmpresa()" v-if="step === 2">
              {{empresa.nome_fantasia}}
              <i class="fa fa-angle-down ml-1 text-primary" v-if="multiple"></i>
            </h6>
            <button class="btn" @click="voltar()" v-else-if="step > 1">
              <i class="fa fa-angle-left mr-1"></i>
              <span>Voltar</span>
            </button>
            <div class="ml-auto">
              <a class="btn btn-info px-3 mr-2" href="https://lecard.tawk.help/article/pedido-manual" target="_blank"><i class="fa fa-question-circle mr-1"></i> Ajuda</a>
              <button class="btn btn-dark px-3" @click="closePedido()">Fechar <i class="fa fa-times ml-1"></i></button>
            </div>
          </div>
          <div v-if="load">
            <loading class="py-4" text="Sincronizando o cardápio.."/>
          </div>
          <div v-else>
            <div class="mt-4" v-if="step === 1">
              <select-empresas @acessarEmpresa="getEmpresa"/>
            </div>
            <div class="row no-gutters" v-if="cardapio.categorias.length && [2,3].includes(step)">
              <div class="col-md-6 col-lg-7 col-xl-8 pr-md-3 d-md-block" :class="{'d-none': step === 3}">
                <div>
                  <div class="d-flex mb-3">
                    <div class="w-100 position-relative mr-2">
                      <input type="text" class="form-control mr-2" id="searchCardapio" placeholder="Pesquisar produto (Alt+P)"
                             v-model="termo" @keyup="handleResult()" @keydown.enter="selecionarProdutoEnter">
                      <button class="btn btn-sm btn-help" @click="clearPesquisa(true)" v-show="termo.length">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M18 6l-12 12" />
                          <path d="M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                    <button :disabled="!selCategoria" class="btn btn-warning text-nowrap px-4 px-md-3 mr-1" @click="toggleCategoria()">
                      <i class="fa fa-list-alt"></i><span class="d-none d-md-inline-block ml-2">Categorias</span>
                    </button>
                  </div>
                  <div>
                    <div class="mb-3" v-if="cardapio.categorias.length">
                      <categorias ref="catManual" :slides="!!(selCategoria || termo.length)" :categorias="cardapio.categorias"
                                  :selCategoria="selCategoria" @openCategoria="openCategoria"/>
                    </div>
                    <div v-show="selCategoria || termo.length">
                      <lista-produtos :produtos="search" @openProduto="openProduto"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-5 col-xl-4 d-md-block" :class="{'d-none': step === 2}">
                <div class="sticky-sacola">
                  <div class="card">
                    <div class="border-bottom d-flex justify-content-between align-items-center p-3">
                      <h6 class="font-weight-bold mb-0">Sacola</h6>
                      <a href="javascript:" class="text-primary text-decoration-none small" @click="clearPedido(true)" v-if="qtd_sacola">Limpar Pedido</a>
                    </div>
                    <revise-pedido :dados="sacola" @editarProduto="editarProduto" @atualizar="totalizar()"/>
                    <div class="border-top p-3 position-relative">
                      <div class="d-flex justify-content-between">
                        <div>Total <span v-if="qtd_sacola">({{sacola.produtos.length}})</span></div>
                        <b>{{subtotal | valor}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="step === 4">
              <finalizar ref="finManual" :empresa="empresa"
                 @openModalPagamento="openModalPagamento"
                 @fechar="closePedido"
                 @voltar="voltar"
                 @salvarSacola="salvarSacola"
                 @changeStep="changeStep"
              />
            </div>
            <div class="fixed-bottom bg-white border-top" v-show="step > 1">
              <div class="d-flex p-2">
                <button type="button" class="btn btn-avancar text-primary text-nowrap d-md-none mr-2" @click="voltar()">
                  <i class="fa fa-chevron-left mr-1"></i> Voltar
                </button>
                <a :class="{'disabled': !qtd_sacola }" class="btn btn-secondary btn-avancar-2" href="javascript:" @click="avancarPedido()">
                  <div v-if="step === 4 && sacola.cliente && sacola.cliente.id_cliente">
                    <icon-pdv name="sacola" size="18" class="mr-1"/> {{ sacola.id_pedido ? 'Salvar' : 'Enviar' }} Pedido
                  </div>
                  <div v-else>
                    Avançar <i class="fa fa-angle-right ml-1"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <produto ref="prodManual" @addSacola="addSacola" @editarProdSacola="editarProdSacola" @fechar="closeProduto" :sacola="sacola" :token="empresa_token"/>
    <formas-pagamento :empresa="empresa" :sacola="sacola" @addPagamento="addPagamento"/>
  </div>
</template>

<script>
import Categorias from "@/components/pedido-manual/Categorias";
import ListaProdutos from "@/components/pedido-manual/ListaProdutos";
import Produto from "@/components/pedido-manual/Produto";
import Finalizar from "@/components/pedido-manual/Finalizar";
import IconPdv from "@/components/pedido-manual/IconPdv";
import Loading from "@/components/gestor/loading";
import FormasPagamento from "@/components/pedido-manual/FormasPagamento";
import VueFuse from 'vue-fuse'
import SelectEmpresas from "@/components/commons/SelectEmpresas";
import RevisePedido from "@/components/pedido-manual/RevisePedido";

export default {
  name: "PedidoManual",
  components: {
    RevisePedido,
    SelectEmpresas, FormasPagamento, Loading, IconPdv, Finalizar, Produto, ListaProdutos, Categorias, VueFuse},
  data() {
    return {
      opened: false,
      token: localStorage.getItem('key'),
      empresa_token: null,
      cardapio: { categorias: [] },
      empresa: {},
      multiple: false,
      selCategoria: null,
      selProduto: null,

      produtos: [],
      termo: '',
      searching: false,
      search: [],

      sacola: {},
      subtotal: 0,
      step: 1,
      finalizar: false,

      franquia: false,
      load: false,
      zonas: []
    }
  },

  methods: {
    getEmpresa(empresa, callback) {
      if (!empresa) {
        return;
      }

      const old_token = this.empresa_token;
      this.empresa_token = empresa.token;

      if (empresa.dados) {
        this.empresa = empresa.dados.empresa;
        this.cardapio = empresa.dados.cardapio;
        this.normalizeProdutos(old_token === empresa.token);

        if (callback) { callback() }
        return;
      }

      this.empresa = {};
      this.load = true;
      const pesquisa = { token: this.empresa_token, pdv: true }
      this.$http.get(this.base_server + 'delivery/v2/empresa', { params: pesquisa })
        .then(response => {
          this.load = false;
          this.step = 2;

          if (response.data && response.data.empresa) {
            empresa.dados = response.data;
            this.empresa = response.data.empresa;
            this.cardapio = response.data.cardapio;

            this.normalizeEmpresa();
            this.normalizeProdutos();

            if (callback) { callback() }
          }

        }, res => {
          this.load = false;
          this.$swal('Não conseguimos atualizar o cardápio do aplicativo, por favor recarregue a página.');
      });
    },

    changeEmpresa() {
      if (this.multiple) {
        this.$swal({
          text: "Deseja alterar de empresa? Sua sacola de produto será zerada.",
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.step = 1;
            this.empresa = {};
            this.clearPedido();
            this.clearPesquisa();
          }
        });

      } else {
        this.step = 2;
        this.clearPesquisa();
      }
    },

    normalizeEmpresa() {
      this.empresa.zonas = this.empresa.zonas ? this.empresa.zonas.map(z => { return {
        ...z, texto: `${z.nome_zona} - R$ ${z.taxa_entrega}`, id: z.id_zona
      }}) : [];

      this.empresa.limitar_cidade = (this.empresa.limitar_cidade === '1');
      this.empresa.tipo_entrega = (this.empresa.integracoes || []).includes('9') ? 3 : this.empresa.zonas.length ? 2 : 1;

      if (this.empresa.tipo_entrega === 3 && this.empresa.gmaps_public_key) {
        this.$googleMaps.init(this.empresa.gmaps_public_key);
      }
    },

    normalizeProdutos(cache) {
      if (this.cardapio.categorias.length) {
        if (!cache) {
          this.produtos = [];
          this.cardapio.categorias.forEach(c => {
            this.produtos = this.produtos.concat(c.produtos.map(p => {
              const normalized = `${p.nome_produto} ${c.nome_categoria}`.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
              return { ...p, normalized, 'nome_categoria': c.nome_categoria, cache: null }
            }))
          });
        }

        this.step = 2;
        this.$nextTick(() => {
          this.clearPesquisa();
        });

      } else {
        this.closePedido();
        this.$swal("Esta empresa não possui produtos cadastrados");
      }
    },

    handleResult() {
      if (this.termo.trim()) {
        this.search = this.produtos.filter(p => p.normalized.includes(this.termo.toLowerCase()));

      } else if (this.selCategoria) {
        this.search = this.produtos.filter(p => p.id_categoria === this.selCategoria);
      }
    },

    openCategoria(c) {
      this.termo = "";
      this.$helpers.focusElement('searchCardapio');
      this.selCategoria = c.id_categoria;
      this.handleResult();
    },

    clearPedido(confirm) {
      if (confirm) {
        if (this.sacola.produtos) {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.$swal({
              title: '',
              text: 'Deseja limpar este pedido?',
              buttons: ['Não','Sim'],
              dangerMode: true
            }).then((r) => {
              if (r) {
                this.sacola = {};
                this.totalizar();
              }
            });
          });
        }

      } else {
        this.sacola = {};
        this.totalizar();
      }

      if (this.$refs.finManual) {
        this.$refs.finManual.clearPedido();
      }
    },

    clearPesquisa(keepCat) {
      this.termo = "";
      this.selCategoria = keepCat ? this.selCategoria : this.cardapio.categorias[0].id_categoria;
      this.handleResult();
      this.$helpers.focusElement('searchCardapio');

      if (this.selCategoria && this.$refs.catManual) {
        this.$refs.catManual.slideTo(this.selCategoria);
      }
    },

    openProduto(p, novo) {
      this.selProduto = p;
      const simplificado = !novo && p.cache && !parseInt(p.cache.divisao) && (window.innerWidth > 767);
      const index = simplificado ? this.validarProdutoSacola(p.cache, (p.cache.tabelas || []).map(t => t.id_tabela_preco)) : -1;

      if (index >= 0) {
        this.sacola.produtos[index].quantidade += 1;
        this.animateCSS(`itemPedido${index}`, 'fadeIn');
        this.totalizar();

      } else {
        this.$refs.prodManual.openProduto(p, novo, (produto) => {
          if (!p.cache) {
            p.cache = JSON.parse(JSON.stringify(produto));
          }
        });
      }
    },

    editarProduto(dados) {
      this.selProduto = dados;
      const produto = this.produtos.find(p => p.id_produto === dados.id_produto);
      this.$refs.prodManual.editarProduto(dados, produto ? produto.cache : null);
    },

    addSacola(dados) {
      if (dados) {
        if (!this.sacola.produtos) {
          this.sacola = {
            token: this.empresa.token,
            empresa: this.empresa.nome_fantasia,
            cliente: {},
            id_pagamento: '',
            pagamento: null,
            tipo_pedido: '',
            produtos: [],
            valor_frete: 0,
            valor_desconto: 0,
            id_cupom: '',
            total: 0,
            troco: 0,
            origin: '3',
            chave_comanda: null,
            obs_pedido: '',
            nolocal: '',
            pedido_pago: '',
            id_endereco: null
          }
        }

        if (window.innerWidth < 768) {
          let index = !dados.adicionais.length && !dados.observacao ? this.validarProdutoSacola(dados, [dados.produto.id_tabela_preco]) : -1;
          const produto = (index >= 0) ? this.sacola.produtos[index] : null;

          if (produto && !produto.divisoes.length) {
            produto.quantidade += dados.quantidade;

          } else {
            this.sacola.produtos.unshift(dados);
          }

        } else {
          this.sacola.produtos.unshift(dados);

          this.$nextTick(() => {
            this.animateCSS(`itemPedido0`, 'fadeIn');
          });
        }
      }

      this.selProduto = null;
      this.totalizar();
    },

    validarProdutoSacola(dados, ids) {
      const produtos = (this.sacola.produtos || []);
      return produtos.findIndex(item => ids.includes(item.produto.id_tabela_preco) && !item.adicionais.length && !item.observacao);
    },

    editarProdSacola(dados) {
      this.selProduto.id_produto = dados.id_produto || null;
      this.selProduto.produto = dados.produto;
      this.selProduto.quantidade = parseFloat(dados.quantidade);
      this.selProduto.observacao = dados.observacao;
      this.selProduto.valor = dados.valor;
      this.selProduto.adicionais = dados.adicionais || [];
      this.selProduto.divisoes = dados.divisoes || [];
      this.selProduto = null;
      this.totalizar();
    },

    salvarSacola(dados) {
      this.sacola = dados;
    },

    voltar() {
      this.step = this.step === 4 && window.innerWidth > 767 ? 3 : this.step;

      switch (this.step) {
        case 2:
          this.closePedido();
          return;

        case 3:
          this.step = 2;
          this.clearPesquisa(true);
          return;

        case 4:
          this.clearPesquisa(true);
          this.step = 2;
          this.finalizar = false;
          return;
      }

      this.step = this.step > 1 ? (this.step - 1) : 1;
    },

    avancarPedido() {
      this.step = this.step === 2 && window.innerWidth > 767 ? 3 : this.step;

      switch (this.step) {
        case 3:
          if (!this.sacola.produtos || !this.sacola.produtos.length) {
            this.$swal('Seu pedido está vazio, adicione um produto para avançar.');
            return;
          }

          this.step = 4;
          this.finalizar = true;
          this.$nextTick(() => {
            this.$refs.finManual.openFinalizar(this.sacola, true);
          });

          break;

        case 4:
          this.$refs.finManual.enviarPedido();
          break;

        default:
          this.step++;
          break;
      }
    },

    selecionarProdutoEnter() {
      this.$helpers.focusElement('listaProd0');
    },

    openModalPagamento(troco, finalizar) {
      this.$emit('openModalPagamento', troco, finalizar);
    },

    addPagamento(dados, finalizar) {
      this.$refs.finManual.addPagamento(dados, finalizar);
    },

    changeStep(step) {
      this.step = step;
    },

    closeProduto() {
      this.selProduto = null;
    },

    closePedido(id_pedido, resposta = {}) {
      this.finalizar = false;
      this.opened = false;

      if (this.sacola.id_pedido || id_pedido) {
        this.clearPedido();

        if (id_pedido) {
          this.$emit('fechar', { ...resposta, id_pedido, token: this.empresa.token });
          this.$refs.finManual.clearPedido();
        }
      }

      if (this.cardapio.categorias.length) {
        this.clearPesquisa();
      }
    },

    animateCSS(element, animationName) {
      const node = document.getElementById(element);

      if (node) {
        node.classList.add('animated', animationName);

        function handleAnimationEnd() {
          node.classList.remove('animated', animationName);
          node.removeEventListener('animationend', handleAnimationEnd);
        }

        node.addEventListener('animationend', handleAnimationEnd)
      }
    },

    openPedidoManual() {
      this.step = 1;
      this.opened = true;

      if (this.sacola.produtos && this.sacola.produtos.length) {
        this.step = 2;
        this.$swal({
          text: "Existe um pedido já aberto, deseja continuar?",
          buttons: ['Novo pedido', 'Continuar'],
          dangerMode: true
        }).then(res => {
          if (!res) {
            this.clearPesquisa();
            this.clearPedido();

            if (this.multiple) {
              this.step = 1;
              this.empresa = {};
            }
          }
        });

      } else {
        if (this.empresas.length === 1) {
          this.getEmpresa(this.empresas[0]);

        } else {
          this.empresa = {};
        }
      }
    },

    editarPedidoManual(dados) {
      this.opened = true;
      this.sacola = dados;
      const empresa = this.empresas.find(e => e.token === dados.token);
      this.getEmpresa(empresa, () => {
        this.$nextTick(() => {
          this.$refs.finManual.openFinalizar(this.sacola, true);
          this.totalizar();
        });
      });
    },

    totalizar() {
      this.subtotal = 0;

      if (this.sacola.produtos) {
        this.sacola.produtos.forEach(p => {
          this.subtotal += (parseFloat(p.quantidade) * parseFloat(p.valor));
        });
      }
    },

    toggleCategoria() {
      this.termo = "";
      this.selCategoria = null;
      this.handleResult();
    }
  },

  mounted() {
    this.multiple = this.empresas.length > 1;
    const el = document.getElementById("modalPedido");

    if (el) {
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closePedido();

        } else if (e.altKey) {
          switch (e.code) {
            case 'KeyF':
              if (this.finalizar) {
                this.$refs.finManual.enviarPedido();

              } else {
                this.avancarPedido();
              }

              break;

            case 'KeyP':
              if (!this.finalizar) {
                this.$helpers.focusElement('searchCardapio');
              }
              break;
          }
        }
      });
    }
  },

  computed: {
    empresas() {
      return this.$store.state.empresas
    },

    qtd_sacola() {
      return this.sacola.produtos ? this.sacola.produtos.length : 0;
    }
  }
}
</script>

<style scoped>
.modal {
  background-color: rgba(0,0,0,0.5);
  z-index: 1090;
}
/* Modal Content/Box */
.modal.full .modal-content {
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  border: none;
  border-radius: 0;
  background-color: var(--light);
  padding: 12px 0 82px;
  overflow-y: scroll;
}

.btn-avancar, .btn-avancar-2 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.btn-avancar-2 {
  min-width: 188px;
  margin-left: auto;
}

@media (min-width: 768px) {
  .sticky-sacola {
    top: 0;
    position: sticky;
    z-index: 9999;
  }

  .btn-avancar-2 {
    width: 100%;
    max-width: 500px;
    margin: auto;
  }
}
</style>
